import { createSeamAxios } from "@seamapi/shared/seam-axios"
import { attachSessionAuthorization } from "./session-authorization"
import { attachSeamDevToolsRecorder } from "core/hooks/seam-dev-tools-recorder"

export function getOrganizationAxios() {
  const axios = createSeamAxios({
    baseURL: process.env.NEXT_PUBLIC_API_HOST,
  })
  attachSessionAuthorization(axios)
  attachSeamDevToolsRecorder(axios, null)
  return axios
}
